var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',{staticStyle:{"height":"60px"}},[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.fullName),function(item,index){return _c('el-breadcrumb-item',{key:index},[_vm._v(_vm._s(item))])}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }